import { Modal, ModalInput, modalConnect } from "@modal";

import { ceModalUpdateState } from "@js/actions/studio/modals.js";

import {
  ceModalEditNameSave,
  ceModalEditNameCancel,
} from "@js/actions/studio/campaign_content_section/modal_edit_name.js";

let ModalEditName = (props) => {
  return (
    <Modal
      title={t("phrases.react_content.action_dropdown.edit_name")}
      onCancel={() => props.dispatch(ceModalEditNameCancel())}
      onSave={() => props.dispatch(ceModalEditNameSave())}
    >
      <ModalInput
        type="text"
        onChange={(e) =>
          props.dispatch(ceModalUpdateState({ name: e.target.value }))
        }
        value={props.name || ""}
        error={props.validation_errors && props.validation_errors.name}
        onEnter={() => props.dispatch(ceModalEditNameSave())}
        autoFocus
      />
    </Modal>
  );
};

export default modalConnect(ModalEditName);
